<template>
  <div class="content-center min-vh-100">
    <transition name="slide-fade" appear>
      <b-card no-body class="overflow-hidden py-4 px-5" style="width: 400px;">
        <img src="logo_n.png" width="150" class="mt-3 mb-5 float-right"/>
        <b-form @submit.stop.prevent="validarCampoUsuario" v-if="verFormularioUsuario">
          <h3 class="text-muted text-left">Módulo Docente</h3>
          <b-input-group class="mb-2">
            <template v-slot:prepend>
              <b-input-group-text><i class="fas fa-user"></i></b-input-group-text>
            </template>
            <b-form-input type="text" id="usuario" name="usuario" v-model="datosLogin.usuario" placeholder="Usuario" maxlength="20" autocomplete="off" autofocus ref="usuario" @keypress="cambioUsuario"></b-form-input>
          </b-input-group>
          <p class="text-left text-danger" v-if="verMensaje">{{ contenidoMensaje }}</p>
          <b-button type="submit" class="btn btn-block mt-4 mb-4" variant="primary">Siguiente</b-button>
          <hr />
          <p class="text-left text-muted">El Usuario es suministrado por la Institución Educativa al momento de registrarse como estudiante, acudiente, docente o administrativo; si no conoce su Usuario, por favor solícitelo en la oficina encargada.</p>
        </b-form>

        <b-form @submit.stop.prevent="validarCampoClave" v-if="verFormularioClave">
          <p class="text-muted text-left"><i class="fas fa-user"></i> Usuario: {{ datosLogin.usuario }}</p>
          <h3 class="text-muted text-left">Digitar Contraseña</h3>
          <b-input-group class="mb-2">
            <template v-slot:prepend>
              <b-input-group-text><i class="fas fa-key"></i></b-input-group-text>
            </template>
            <b-form-input type="password" id="clave" name="clave" v-model="datosLogin.clave" placeholder="Contraseña" maxlength="20" autocomplete="off" ref="clave" @keypress="cambioClave"></b-form-input>
          </b-input-group>
          <p class="text-left text-danger" v-if="verMensaje">{{ contenidoMensaje }}</p>
          <b-button type="submit" class="btn btn-block mt-4 mb-4" variant="primary">Iniciar Sesión</b-button>
          <hr />
          <p class="text-left text-muted">
            <b-button variant="link" class="text-muted p-0" @click="verFormularioUsuario=true, verFormularioClave=false,verFormularioRecuperarClave=false,verMensaje=false"><i class="fas fa-angle-double-left"></i></b-button>
          </p>
          <p class="text-right text-muted" @click="verFormularioUsuario=false, verFormularioClave=false,verFormularioRecuperarClave=true,verMensaje=false">¿Olvido su contraseña?.</p>
        </b-form>

        <b-form @submit.stop.prevent="validarCampoCorreo" v-if="verFormularioRecuperarClave">
          <p class="text-left text-muted">Si ha olvidado la contraseña, puede recuperar los datos de inicio de sesión ingresando su correo electrónico registrado en el sistema. Se enviará un correo con los datos de su cuenta.</p>
          <h3 class="text-muted text-left">Digite su Correo</h3>
          <b-input-group class="mb-2">
            <template v-slot:prepend>
              <b-input-group-text><i class="fas fa-envelope"></i></b-input-group-text>
            </template>
            <b-form-input type="text" id="correo" name="correo" v-model="datosLogin.correo" placeholder="Correo electrónico" maxlength="50" autocomplete="off" ref="correo" @keypress="cambioCorreo"></b-form-input>
          </b-input-group>
          <p class="text-left text-danger" v-if="verMensaje">{{ contenidoMensaje }}</p>
          <b-button type="submit" class="btn btn-block mt-4 mb-4" variant="primary">Enviar Correo</b-button>
          <hr />
          <p class="text-left text-muted">
            <b-button variant="link" class="text-muted p-0" @click="verFormularioUsuario=true, verFormularioClave=false,verFormularioRecuperarClave=false,verMensaje=false"><i class="fas fa-angle-double-left"></i></b-button>
          </p>
        </b-form>
      </b-card>
    </transition>
  </div>
</template>

<script>
  import axios from "axios"
  import * as CONFIG from '@/assets/config.js'
  import categorias from "@/assets/tablas/categorias.js";
  import municipios from "@/assets/tablas/municipios.js";
  import documentos from "@/assets/tablas/documentos.js";
  import generos from "@/assets/tablas/generos.js";
  import rhs from "@/assets/tablas/rhs.js";

  export default {
    name: 'Login',
    data() {
      return {
        datosLogin: {
          usuario: '',
          clave: '',
          correo: ''
        },
        datosConsultaUsuario: {},
        verMensaje: false,
        contenidoMensaje: '',
        verFormularioUsuario: true,
        verFormularioClave: false,
        verFormularioRecuperarClave: false
      }
    },
    methods: {
      validarInicio(){
        var vars = [], hash = [], getIdColegio = ''
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&')
        this.$store.commit('set', ['idUsuario', ''])
        this.$store.commit('set', ['rutaIngreso', window.location.href])
        for(var i = 0; i < hashes.length; i++) {
            hash = hashes[i].split('=')
            vars.push(hash[0])
            vars[hash[0]] = hash[1]
            if (hash[0] == 'cid' && hash[1] > 0)
              getIdColegio = hash[1]
        }
        if (getIdColegio == '') {
          this.$router.push("*")
        } else {
          this.consultarColegio(getIdColegio)
        }
      },
      async consultarColegio(getIdColegio) {
        // Consulta Colegio en la tabla Colegios
        await axios
        .get(CONFIG.ROOT_PATH + 'colegios/' + getIdColegio)
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente('danger','Mensaje',response.data.mensaje)
          } else{
            if (response.data.datos != 0){
              // Asigna los datos a la Store de la tabla Colegios
              this.$store.commit('set', ['idColegio', getIdColegio])
              this.$store.commit('set', ['daneColegio', response.data.datos.dane])
              this.$store.commit('set', ['nitColegio', response.data.datos.nit])
              this.$store.commit('set', ['nombreColegio', response.data.datos.nombre])
              let resultadoCategoria = categorias.find( itemCategoria => itemCategoria.id === String(response.data.datos.id_categoria))
              this.$store.commit('set', ['categoriaColegio', resultadoCategoria.categoria.toUpperCase()])
              this.$store.commit('set', ['direccionColegio', response.data.datos.direccion])
              let resultadoMunicipio = municipios.find( itemMunicipio => itemMunicipio.id === String(response.data.datos.id_municipio))
              this.$store.commit('set', ['municipioColegio', resultadoMunicipio.municipio])
              this.$store.commit('set', ['departamentoColegio', resultadoMunicipio.departamento])
              this.$store.commit('set', ['telefonoColegio', response.data.datos.telefono])
              this.$store.commit('set', ['bdColegio', response.data.datos.bd])
              let escudoColegio = 'https://sised.com.co/APISised/colegios/' + response.data.datos.bd + '/escudos/es' + getIdColegio + '.jpg'
              this.$store.commit('set', ['escudoColegio', escudoColegio])
              // AQUI HAY QUE TRAER UNA VARIABLE QUE DEFINE EL AÑO LECTIVO DE LA CONSULTA
              this.$store.commit('set', ['lectivoColegio', 2021])
              // AQUI HAY QUE TRAER UNA VARIABLE QUE DEFINE EL PERIODO DE LA CONSULTA
              this.$store.commit('set', ['periodoColegio', 1])
            } else {
              this.$router.push("/pages/colegioinactivo")
            }
          }
        })
        .catch(err => {
          if (err.message === 'Network Error')
            this.mensajeEmergente('danger','Mensaje','Conexión denegada!. Revise su conexión a Internet y vuelva a intentarlo.');
          else
            this.mensajeEmergente('danger','Mensaje','Se ha detectado un error inesperado!. Por favor intente más tarde. ' + err.message);
        })
      },
      validarCampoUsuario() {
        if (this.datosLogin.usuario != '') {
          this.consultarUsuario()
        } else {
          this.verMensaje = true
          this.contenidoMensaje = 'Este campo no puede estar vacio. Por favor digite el Usuario.'
          this.$refs.usuario.focus()
        }
      },
      cambioUsuario() {
        this.verMensaje = false
        this.contenidoMensaje = ''
      },
      async consultarUsuario() {
        // Consulta Estudiante en la tabla estudiantes JOIN matriculas de la base de datos del colegio
        await axios
        .get(CONFIG.ROOT_PATH + 'usuarios/docente', { params: { usuario: this.datosLogin.usuario, bd: this.$store.state.bdColegio }})
        .then(response => {
          if (response.data.error){
            this.mensajeEmergente('danger','Mensaje',response.data.mensaje)
          } else{
            if (response.data.datos != 0){
              if (response.data.datos.id_estado == 1) {
                // Asigna los datos a la Store de la tabla Estudiantes y Matriculas
                this.$store.commit('set', ['idRolUsuario', 6]) // Rol docente = 6
                this.$store.commit('set', ['rolUsuario', 'Docente'])
                this.$store.commit('set', ['idUsuario', response.data.datos.id_docente])
                this.$store.commit('set', ['usuarioUsuario', response.data.datos.usuario])
                this.$store.commit('set', ['claveUsuario', response.data.datos.clave])
                this.$store.commit('set', ['nombresUsuario', response.data.datos.nombres])
                this.$store.commit('set', ['apellidosUsuario', response.data.datos.apellidos])
                let fotoUsuario = 'https://sised.com.co/APISised/colegios/' + this.$store.state.bdColegio + '/fotos/docentes/' + response.data.datos.foto
                this.$store.commit('set', ['fotoUsuario', fotoUsuario])
                //let resultadoTipo = documentos.find( itemDocumento => itemDocumento.id === String(response.data.datos.id_tipo_documento))
                let resultadoTipo = 'Cédula de Ciudadanía'
                this.$store.commit('set', ['tipoDocumentoUsuario', resultadoTipo])
                this.$store.commit('set', ['documentoUsuario', response.data.datos.usuario])
                this.verFormularioUsuario = false
                this.verFormularioRecuperarClave = false
                this.verMensaje = false
                this.verFormularioClave = true
              } else {
                this.verMensaje = true
                this.contenidoMensaje = 'El Usuario ' + this.datosLogin.usuario + ' se encuentra registrado pero su estado es: Inactivo.'
                this.$refs.usuario.focus()
                this.datosLogin.usuario = ''
              }
            } else {
              this.verMensaje = true
              this.contenidoMensaje = 'El Usuario ' + this.datosLogin.usuario + ' no se encuentra registrado.'
              this.$refs.usuario.focus()
              this.datosLogin.usuario = ''
            }
          }
        })
        .catch(err => {
          if (err.message === 'Network Error')
            this.mensajeEmergente('danger','Mensaje','Conexión denegada!. Revise su conexión a Internet y vuelva a intentarlo.');
          else
            this.mensajeEmergente('danger','Mensaje','Se ha detectado un error inesperado!. Por favor intente más tarde. ' + err.message);
        })
      },
      validarCampoClave() {
        if (this.datosLogin.clave != '') {
          if (this.datosLogin.clave == this.$store.state.claveUsuario) {
              // Asigna los datos a la Store de la tabla Usuarios
              this.mensajeEmergente('success','Bienvenido','El Usuario y la Contraseña son válidas,  procesando el inicio de la sesión...')
              sessionStorage.setItem('token', this.$store.state.idUsuario)
              this.$router.push("/")
          } else {
            this.verMensaje = true
            this.contenidoMensaje = 'Lo sentimos, la Contraseña no es válida.'
            this.$refs.clave.focus()
          }
        } else {
          this.verMensaje = true
          this.contenidoMensaje = 'Este campo no puede estar vacio. Por favor digite la Contraseña.'
          this.$refs.clave.focus()
        }
      },
      cambioClave() {
        this.verMensaje = false
        this.contenidoMensaje = ''
      },





      validarCampoCorreo() {
        if (this.datosLogin.correo != '') {
          if (this.datosLogin.correo == this.datosConsultaUsuario.correo) {
            alert('El correo se ha enviado.')
            this.verFormularioUsuario = true
            this.verFormularioClave = false
            this.verFormularioRecuperarClave = false
            this.verMensaje = false
          } else {
            this.verMensaje = true
            this.contenidoMensaje = 'Lo sentimos, el correo electrónico no coincide con el correo registrado en el sistema.'
            this.$refs.correo.focus()
          }
        } else {
          this.verMensaje = true
          this.contenidoMensaje = 'Este campo no puede estar vacio. Por favor digite el Correo.'
          this.$refs.correo.focus()
        }
      },
      cambioCorreo() {
        this.verMensaje = false
        this.contenidoMensaje = ''
      },
      mensajeEmergente(variante, titulo, contenido) {
        this.$bvToast.toast(contenido, { title: titulo, variant: variante, toaster: "b-toaster-top-center", solid: true, autoHideDelay: 4000, appendToast: false })
      }
    },
    beforeMount() {
      this.validarInicio()
    }
  }
</script>
